(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxAddUser(
    $timeout, $filter, toastr, $http, UserListService, $translate, $focus, $rootScope,
    RegexModel
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/setup/addUser/addUser.template.html',
      link: function(scope) {

        const regex = new RegexModel();
        scope.newUserDetails = {
          email: null, 
          grantAdminAccess: false
        };
        scope.deleteUserAfterPeriod = false;
        scope.deleteUserAfterNDays = 10;
        scope.userEmailAddressFocusKey = "userEmailAddressFocusKey";
        scope.currentOEM = $rootScope.currentOEM;
        scope.currentAppName = $rootScope.currentAppName;
        scope.emailValid = false;

        scope.checkEmail = function () {
          if (regex.emailRegex().test(scope.newUserDetails.email)) {
            return scope.emailValid = true;
          }
          return scope.emailValid = false;
        }

        scope.addUser = function () {
          var dataToSend = {
            email: scope.newUserDetails.email,
            lang: $translate.use(),
            grantAdminAccess: scope.newUserDetails.grantAdminAccess
          };
          UserListService.createUser(dataToSend).then(function () {
            scope.newUserDetails = {
              email: null,
              grantAdminAccess: false
            };
            toastr.success($filter("translate")("EmailSent"));
          }).catch(function(error){});
      };

      $focus(scope.userEmailAddressFocusKey);

      }
    };
  }

  pxAddUser.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'UserListService', '$translate', 'focus', '$rootScope',
    'RegexModel'
  ];

  angular
    .module('printix-admin')
    .directive('pxAddUser', pxAddUser);

})();
